import { useEffect, useState } from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

import api from "../services/api";
import Navbar from "../components/Navbar";
import "../styles/tables.css";
import { useAuth } from "../context/AuthContext";

function ManageExams() {
  const { token } = useAuth();
  const navigate = useNavigate();

  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] =
    useState(1);

  const examsPerPage = 10;

  useEffect(() => {
    fetchExams();
  }, []);

  const fetchExams = async () => {
    try {
      const response = await api.get("/exams");

      setExams(response.data);

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (examId) => {

    const result = await Swal.fire({
      title: "Delete Exam?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ef4444",
      cancelButtonColor: "#021658",
      confirmButtonText: "Delete",
      cancelButtonText: "Cancel"
    });

    if (!result.isConfirmed) {
      return;
    }

    try {

      await api.delete(
        `/exams/${examId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setExams(
        exams.filter(
          (exam) => exam.id !== examId
        )
      );

      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "Exam deleted successfully.",
        timer: 2000,
        showConfirmButton: false
      });

    } catch (error) {

      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Delete Failed",
        text:
          error.response?.data?.message ||
          "Unable to delete exam."
      });

    }
  };

  const filteredExams =
    exams.filter((exam) =>
      exam.title
        .toLowerCase()
        .includes(
          search.toLowerCase()
        )
    );

  const indexOfLastExam =
    currentPage * examsPerPage;

  const indexOfFirstExam =
    indexOfLastExam - examsPerPage;

  const currentExams =
    filteredExams.slice(
      indexOfFirstExam,
      indexOfLastExam
    );

  const totalPages = Math.ceil(
    filteredExams.length /
    examsPerPage
  );

  if (loading) {
    return (
      <div>
        <Navbar />
        <h2>Loading...</h2>
      </div>
    );
  }

  return (
    <div>
      <Navbar />

      <div className="container">

        <h1>Manage Exams</h1>

        <input
          type="text"
          placeholder="Search exams..."
          value={search}
          onChange={(e) =>
            setSearch(e.target.value)
          }
          className="search-input"
        />

        <div className="table-wrapper">

          <table className="custom-table">

            <thead>
              <tr>
                <th>ID</th>
                <th>Title</th>
                <th>Category</th>
                <th>Price</th>
                <th>Downloads</th>
                <th>Free</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>

              {currentExams.map(
                (exam) => (
                  <tr key={exam.id}>

                    <td>{exam.id}</td>

                    <td>
                      {exam.title}
                    </td>

                    <td>
                      {exam.category}
                    </td>

                    <td>
                      KES {exam.price}
                    </td>

                    <td>
                      {exam.downloads_count}
                    </td>

                    <td>
                      {exam.is_free
                        ? "Yes"
                        : "No"}
                    </td>

                    <td>

                      <button
                        title="Edit Exam"
                        className="icon-btn edit-btn"
                        onClick={() =>
                          navigate(
                            `/exams/edit/${exam.id}`
                          )
                        }
                      >
                        <FaEdit />
                      </button>

                      <button
                        title="Delete Exam"
                        className="icon-btn delete-btn"
                        onClick={() =>
                          handleDelete(
                            exam.id
                          )
                        }
                      >
                        <FaTrash />
                      </button>

                    </td>

                  </tr>
                )
              )}

            </tbody>

          </table>

        </div>

        <div className="pagination">

          <button
            disabled={
              currentPage === 1
            }
            onClick={() =>
              setCurrentPage(
                currentPage - 1
              )
            }
          >
            Previous
          </button>

          <span>
            Page {currentPage} of{" "}
            {totalPages || 1}
          </span>

          <button
            disabled={
              currentPage === totalPages ||
              totalPages === 0
            }
            onClick={() =>
              setCurrentPage(
                currentPage + 1
              )
            }
          >
            Next
          </button>

        </div>

      </div>
    </div>
  );
}

export default ManageExams;